/* Mobile menu burger toggle */
(function () {
    const navigation = document.body;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.setAttribute('aria-expanded', 'false');

    const mobile = window.matchMedia('(max-width: 767px)');
    const root = document.documentElement;
    let scrollPosition = 0;

    function closeMenu() {
        if (!navigation.classList.contains('gh-head-open')) return;

        navigation.classList.remove('gh-head-open');
        burger.setAttribute('aria-expanded', 'false');
        root.classList.remove('gh-navigation-open');
        root.style.removeProperty('--gh-navigation-scroll-top');
        window.scrollTo({top: scrollPosition, behavior: 'instant'});
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('gh-head-open')) {
            if (!mobile.matches) return;

            scrollPosition = window.scrollY;
            root.style.setProperty('--gh-navigation-scroll-top', `${-scrollPosition}px`);
            root.classList.add('gh-navigation-open');
            navigation.classList.add('gh-head-open');
            burger.setAttribute('aria-expanded', 'true');
        } else {
            closeMenu();
        }
    });

    mobile.addEventListener('change', function () {
        if (!mobile.matches) closeMenu();
    });
})();

/* Moment card metadata from Ghost Code Injection Head */
(function () {
    function extractMetaContentFromHead(headString, metaName) {
        if (!headString) {
            return null;
        }

        const escapedName = metaName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const metaPattern = new RegExp(`<meta\\s+[^>]*name=["']${escapedName}["'][^>]*>`, "i");
        const tagMatch = headString.match(metaPattern);

        if (!tagMatch) {
            return null;
        }

        const contentMatch = tagMatch[0].match(/\bcontent=["']([^"']+)["']/i);

        if (!contentMatch) {
            return null;
        }

        const textarea = document.createElement("textarea");
        textarea.innerHTML = contentMatch[1];

        return textarea.value;
    }

    function initMomentCard(card) {
        const head = card.getAttribute("data-codeinjection-head");
        const momentUrl = extractMetaContentFromHead(head, "maaike-external-url")
            || extractMetaContentFromHead(head, "maaike-favorite-url")
            || extractMetaContentFromHead(head, "maaike-url");
        const rating = parseFloat(extractMetaContentFromHead(head, "maaike-rating"));
        const link = card.querySelector(".alx-moment-card-link");
        const ratingElement = card.querySelector(".alx-moment-card-rating");

        if (link) {
            if (!momentUrl) {
                link.removeAttribute("href");
                link.removeAttribute("target");
                link.removeAttribute("rel");
                card.classList.add("alx-moment-card-no-link");
            } else {
                link.setAttribute("href", momentUrl);
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener");
                card.classList.remove("alx-moment-card-no-link");
            }
        }

        if (ratingElement && Number.isFinite(rating)) {
            const normalizedRating = Math.max(0, Math.min(5, Math.round(rating * 2) / 2));
            ratingElement.style.setProperty("--maaike-rating-percent", `${normalizedRating * 20}%`);
            ratingElement.setAttribute("aria-label", `${normalizedRating} van 5 sterren`);
            ratingElement.hidden = false;
        } else if (ratingElement) {
            ratingElement.hidden = true;
        }
    }

    document.querySelectorAll(".alx-moment-card").forEach(initMomentCard);

    document.querySelectorAll("[data-maaike-favorite-groups]").forEach((feed) => {
        const groupedCards = new Map();

        feed.querySelectorAll(".alx-moment-card").forEach((card) => {
            const groupName = extractMetaContentFromHead(card.getAttribute("data-codeinjection-head"), "maaike-favorite-group");

            if (!groupName) {
                return;
            }

            if (!groupedCards.has(groupName)) {
                groupedCards.set(groupName, []);
            }

            groupedCards.get(groupName).push(card);
        });

        if (!groupedCards.size) {
            return;
        }

        const parent = feed.parentElement;
        const referenceNode = feed.nextSibling;

        Array.from(groupedCards.entries()).sort(([firstName], [secondName]) => {
            return firstName.localeCompare(secondName, "nl", {sensitivity: "base"});
        }).forEach(([groupName, cards]) => {
            const section = document.createElement("section");
            section.className = "alx-favorite-subgroup";
            section.setAttribute("aria-label", groupName);

            const heading = document.createElement("h2");
            heading.className = "alx-favorite-subgroup-title";
            heading.textContent = groupName;

            const groupFeed = document.createElement("div");
            groupFeed.className = "alx-moments-archive-feed alx-favorites-subgroup-feed";

            cards.forEach((card) => {
                groupFeed.appendChild(card);
            });

            section.append(heading, groupFeed);
            parent.insertBefore(section, referenceNode);
        });

        if (!feed.querySelector(".alx-moment-card")) {
            feed.remove();
        }
    });
})();
